import React, {useEffect, useState} from 'react';
import api from 'services/api';  // Ton service API pour récupérer les données
import styles from './SocialLinks.module.css';  // Optionnel, fichier de styles
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';  // FontAwesome pour les icônes
import {faFacebook, faLinkedin, faTwitter, faInstagram, faXTwitter, faTiktok} from '@fortawesome/free-brands-svg-icons';  // Importer les icônes
import {useSubSite} from 'contexts/SubSiteContext'; // Hook pour vérifier le sous-site

const SocialLinks = () => {
    const [socialLinks, setSocialLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const {isSubSite, subSiteSlug} = useSubSite();

    // Fonction pour récupérer les réseaux sociaux depuis l'API
    useEffect(() => {
        const fetchSocialLinks = async () => {
            try {
                setLoading(true);
                console.log("Tentative de récupération des réseaux sociaux, isSubSite:", isSubSite, "subSiteSlug:", subSiteSlug);

                let response;
                /*if (isSubSite) {
                    // Pour les sous-sites, utiliser l'URL spécifique
                    response = await api.get(`/general-informations/social-networks/${subSiteSlug}`);
                    console.log("Réponse sous-site:", response.data);
                } else {
                    // Pour le site principal
                    response = await api.get('/general-informations/social-networks');
                    console.log("Réponse site principal:", response.data);
                }*/

                response = await api.get('/general-informations/social-networks/pharos');

                setSocialLinks(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Erreur lors de la récupération des réseaux sociaux:', error);
                // En cas d'erreur pour un sous-site, tenter de récupérer les réseaux du site principal
                if (isSubSite) {
                    try {
                        console.log("Tentative de fallback vers les réseaux sociaux du site principal");
                        const fallbackResponse = await api.get('/general-informations/social-networks');
                        setSocialLinks(fallbackResponse.data);
                    } catch (fallbackError) {
                        console.error('Erreur lors du fallback:', fallbackError);
                    }
                }
                setLoading(false);
            }
        };

        fetchSocialLinks();
    }, [isSubSite, subSiteSlug]); // Dépendances à jour

    // Correspondance entre les noms d'icônes et les icônes de FontAwesome
    const iconMap = {
        facebook: faFacebook,
        twitter: faXTwitter,
        instagram: faInstagram,
        linkedin: faLinkedin, // Ajouter d'autres icônes ici si nécessaire
    };

    if (loading) return <p>Chargement des réseaux sociaux...</p>;

    return (<div className={`${styles.socialsContainer}`}>
        <p>
            <span>Suivez-nous sur les réseaux</span>{" "}
            

                {socialLinks && socialLinks.length > 0 ? (
          socialLinks.map((social) => (
            <span key={social.id || social.name}>
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                className={styles.socialLink}
              >
                <FontAwesomeIcon icon={iconMap[social.icon] || faTiktok} className={styles.icon} />
              </a>
            </span>
          ))
        ) : (
          <li>Aucun réseau social disponible</li>
        )}
        </p>

    </div>);
};

export default SocialLinks;
